const BANK_AUTHORISATION_ERROR = "bankauth";

/**
 * Return failed ecommerce bank authorisations to the merchant checkout.
 *
 * The bank's return to the callback (`?error=bankauth`) is proof enough on
 * its own: an ecommerce checkout carries no status of its own, so waiting
 * for one left the shopper on the bank chooser of a checkout whose store
 * order had already been cancelled. The QR/poll path observes the payment
 * status directly and keeps requiring a failed one.
 */
export function getExternalBankFailureUrl({
  flowId,
  status,
  cancelUrl,
  search = "",
  bankAuthorisationFailed = false,
}) {
  if (flowId !== "checkout" || !cancelUrl) {
    return null;
  }

  const error = new URLSearchParams(search).get("error");
  if (error === BANK_AUTHORISATION_ERROR) {
    return cancelUrl;
  }

  const failedStatus = status === "Cancelled" || status === "PaymentFailed";
  return bankAuthorisationFailed && failedStatus ? cancelUrl : null;
}

/**
 * Where QR/poll Open Banking goes once Yapily reports PaymentSucceeded.
 *
 * The checkout flow has no success route of its own: its end state is the
 * merchant's success URL, reached from the processing page once the checkout
 * reports paidOn. Sending it to `/checkout/:id/success` lands on the 404 page
 * inside the merchant's iframe.
 */
export function getBankPaymentSucceededPath({ flowId, id, paymentId }) {
  const query = `p-id=${paymentId}&t=openbanking`;
  const step = flowId === "checkout" ? "processing" : "success";

  return `/${flowId}/${id}/${step}?${query}`;
}

/**
 * The payment method route to open straight away when the merchant checkout
 * allows exactly one method: the shopper has already confirmed the order on
 * the store, so a one-item chooser is a step for nothing.
 */
export function getSoleCheckoutMethodRoute({ flowId, options }) {
  if (flowId !== "checkout") return null;

  const valid = options.filter((option) => option.valid);
  return valid.length === 1 ? valid[0].route : null;
}
